import { useFormContext } from 'react-hook-form'
import { Log } from '@/types/logs'
import { OfficialReportType } from '@/types/officialReport'
import { FormValuesType } from '../../schema'
import { buildDescription } from '../../helpers/generateDetails'
import styles from '../OfficialReportModal.module.scss'
import clsx from 'clsx'

interface Props {
    log: Log
    type: OfficialReportType
}

export const DescriptionPreview = ({ log, type }: Props) => {
    const { watch } = useFormContext<FormValuesType>()
    const values = watch()
    const description = buildDescription(type, log, values)

    return (
        <div className={styles.wrapper}>
            <p className={styles.subtitle}>Report preview</p>
            <span
                className={clsx(styles.text, styles.details)}
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </div>
    )
}
